function formatValue(val) {
  if (!val) {
    return 0;
  } else if (isNaN(val)) {
    return val;
  } else {
    val = Number(val);
    val /= 1000;
    val = Math.abs(val);
    val = Math.round(val);
    return val;
  }
}

function returnRoundedWithUnit(unit, value) {
  let formattedValue = Number(formatValue(value).toLocaleString('de-DE'));
  if (isNaN(Number(formatValue(value)))) formattedValue = '--';
  return `${formattedValue} <span class="unit">${unit}</span>`;
}

export default returnRoundedWithUnit;
